import { useTranslation } from "react-i18next";
import { Smartphone } from "lucide-react";
import FadeInUp from "./FadeInUp";

/* Glyphes de plateforme (SVG simples — badges "coming soon" maison,
   PAS les images officielles Apple/Google réservées aux liens store live). */
const AppleGlyph = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.05 12.536c-.03-2.7 2.205-3.995 2.305-4.06-1.255-1.835-3.21-2.086-3.905-2.115-1.665-.168-3.245.98-4.09.98-.84 0-2.14-.955-3.52-.93-1.81.027-3.48 1.053-4.41 2.674-1.88 3.263-.48 8.092 1.35 10.74.89 1.296 1.955 2.752 3.35 2.7 1.345-.054 1.85-.87 3.475-.87 1.62 0 2.08.87 3.5.84 1.445-.024 2.36-1.32 3.245-2.622 1.022-1.504 1.443-2.96 1.468-3.035-.032-.014-2.815-1.08-2.843-4.282zM14.39 4.66c.745-.9 1.245-2.154 1.108-3.4-1.072.043-2.37.714-3.137 1.613-.688.797-1.29 2.07-1.128 3.292 1.195.093 2.413-.607 3.157-1.505z" />
  </svg>
);

const GooglePlayGlyph = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M3.6 1.2c-.36.2-.6.58-.6 1.06v19.48c0 .48.24.86.6 1.06l11.07-10.8L3.6 1.2zM16.1 8.62l-2.7 2.63 2.7 2.63 3.62-2.06c.43-.25.43-.95 0-1.2L16.1 8.62zM14.67 11.25 4.3 1.13l10.96 6.32 1.5-1.45-2.09 5.25zM4.3 22.87l10.37-10.12-1.4-1.36-8.97 11.48z" />
  </svg>
);

const SoonBadge = ({ glyph, line1, line2 }) => (
  <div
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: "10px",
      padding: "10px 18px",
      borderRadius: "12px",
      backgroundColor: "#0f1011",
      border: "1px solid #23252a",
      color: "#8a8f98",
      position: "relative",
      cursor: "default",
      userSelect: "none",
    }}
    aria-disabled="true"
  >
    <span style={{ color: "#d0d6e0", display: "flex" }}>{glyph}</span>
    <span style={{ display: "flex", flexDirection: "column", lineHeight: 1.1, textAlign: "left" }}>
      <span style={{ fontSize: "10px", letterSpacing: "0.3px" }}>{line1}</span>
      <span style={{ fontSize: "16px", fontWeight: 600, color: "#f7f8f8" }}>{line2}</span>
    </span>
    <span
      style={{
        marginLeft: "4px",
        fontSize: "9px",
        fontWeight: 600,
        letterSpacing: "0.4px",
        textTransform: "uppercase",
        padding: "2px 7px",
        borderRadius: "9999px",
        color: "#5e6ad2",
        backgroundColor: "rgba(94,106,210,0.12)",
        border: "1px solid rgba(94,106,210,0.2)",
      }}
    >
      ●
    </span>
  </div>
);

const LandingAppBadges = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const t = (obj) => obj[lang] || obj.fr;

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: "var(--lm-canvas)" }}>
      <div className="max-w-3xl mx-auto" style={{ textAlign: "center" }}>
        <FadeInUp>
          <span
            style={{
              display: "inline-flex", alignItems: "center", gap: "6px",
              fontSize: "12px", fontWeight: 500, letterSpacing: "0.4px",
              textTransform: "uppercase", padding: "4px 14px", borderRadius: "9999px",
              color: "#5e6ad2", backgroundColor: "rgba(94,106,210,0.10)",
              border: "1px solid rgba(94,106,210,0.20)", marginBottom: "18px",
            }}
          >
            <Smartphone style={{ width: "13px", height: "13px" }} />
            {t({ fr: "Application mobile", en: "Mobile app", ar: "تطبيق الجوال" })}
          </span>

          <h2 style={{ color: "#f7f8f8", fontSize: "clamp(24px, 3.5vw, 34px)", fontWeight: 600, letterSpacing: "-0.8px", marginBottom: "12px" }}>
            {t({ fr: "Emportez Mawered partout", en: "Take Mawered everywhere", ar: "خذ Mawered معك أينما كنت" })}
          </h2>
          <p style={{ color: "#8a8f98", fontSize: "16px", lineHeight: 1.5, marginBottom: "28px" }}>
            {t({
              fr: "Pointage géolocalisé, congés, validations et notifications — sur iOS et Android. Bientôt disponible.",
              en: "Geolocated check-in, leave, approvals and notifications — on iOS and Android. Coming soon.",
              ar: "تسجيل حضور محدد الموقع وإجازات وموافقات وإشعارات — على iOS و Android. قريبًا.",
            })}
          </p>

          <div style={{ display: "flex", gap: "14px", justifyContent: "center", flexWrap: "wrap" }}>
            <SoonBadge
              glyph={<AppleGlyph />}
              line1={t({ fr: "Bientôt sur l'", en: "Soon on the", ar: "قريبًا على" })}
              line2="App Store"
            />
            <SoonBadge
              glyph={<GooglePlayGlyph />}
              line1={t({ fr: "Bientôt sur", en: "Soon on", ar: "قريبًا على" })}
              line2="Google Play"
            />
          </div>
        </FadeInUp>
      </div>
    </section>
  );
};

export default LandingAppBadges;
